<div class="container">
  <div class="header">
    <pdq-heading element="h3">{{ title }}</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      @if (safeIframeUrl) {
        <iframe [src]="safeIframeUrl" [style.height]="iframeHeight" frameborder="0"></iframe>
      }
    </div>
  </div>
</div>
